import { useCallback } from 'react'

import { useAtomValue, useSetAtom } from 'jotai'

import {
  expandedNodeTypesAtom,
  toggleNodeTypeExpandedAtom
} from 'Automations/automationEditor/atoms'
import { NodeType } from '../types'
import { useNode } from './useNode'

/**
 * Ephemeral, type-keyed expansion state for a node. `isExpanded` reflects
 * whether the node's type is currently expanded, and `toggle()` expands (or
 * collapses) *every* node of that type. Whether a node is *expandable* is
 * decided by its `editorNode` passing `expandedContent` to `EditorNodeTemplate`,
 * not by this hook.
 */
export const useNodeExpansion = ({ nodeId }: { nodeId: string }) => {
  const { node } = useNode({ nodeId })
  const expandedNodeTypes = useAtomValue(expandedNodeTypesAtom)
  const toggleNodeTypeExpanded = useSetAtom(toggleNodeTypeExpandedAtom)

  const nodeType = node?.type as NodeType | undefined
  const isExpanded = nodeType ? expandedNodeTypes.has(nodeType) : false

  const toggle = useCallback(() => {
    if (!nodeType) return
    toggleNodeTypeExpanded(nodeType)
  }, [nodeType, toggleNodeTypeExpanded])

  return { isExpanded, toggle }
}
